import RefineryForm from "./RefineryForm";

function AddRefinery() {
  return <RefineryForm mode="create" />;
}

export default AddRefinery;
